module.exports = __webpack_public_path__ + "fonts/iconfont.c561d72.woff";